import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { useAuthStore } from './store';
import { Layout } from './components/layout';
import { AdminLayout } from './components/admin/AdminLayout';

// Pages
import Home from './pages/Home.js';
import Jobs from './pages/Jobs';
import { JobDetail } from './pages/JobDetail';
import { AdminLogin } from './pages/admin/AdminLogin';
import { AdminDashboard } from './pages/admin/AdminDashboard';

// Additional pages (placeholder components)
const About = () => <div className="p-8">About Page</div>;
const Contact = () => <div className="p-8">Contact Page</div>;
const Privacy = () => <div className="p-8">Privacy Policy</div>;
const Terms = () => <div className="p-8">Terms of Service</div>;
const NotFound = () => (
  <div className="min-h-screen flex items-center justify-center">
    <div className="text-center">
      <h1 className="text-4xl font-bold text-secondary-900 mb-4">404</h1>
      <p className="text-secondary-600">Page not found</p>
    </div>
  </div>
);

// Admin placeholder pages
const AdminJobs = () => <div className="p-8">Admin Jobs Management</div>;
const AdminApplications = () => <div className="p-8">Admin Applications Management</div>;
const AdminUsers = () => <div className="p-8">Admin Users Management</div>;
const AdminNewsletter = () => <div className="p-8">Admin Newsletter Management</div>;
const AdminSettings = () => <div className="p-8">Admin Settings</div>;

function App() {
  const { initializeAuth } = useAuthStore();

  useEffect(() => {
    // Initialize authentication state from localStorage
    initializeAuth();
  }, [initializeAuth]);
  
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="jobs" element={<Jobs />} />
            <Route path="jobs/:id" element={<JobDetail />} />
            <Route path="about" element={<About />} />
            <Route path="contact" element={<Contact />} />
            <Route path="privacy" element={<Privacy />} />
            <Route path="terms" element={<Terms />} />
          </Route>

      

          {/* 404 Route */}
          <Route path="*" element={<NotFound />} />
        </Routes>

        {/* Global Toast Container */}
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
            },
            success: {
              duration: 3000,
              style: {
                background: '#0284c7',
              },
            },
            error: {
              duration: 5000,
              style: {
                background: '#DC2626',
              },
            },
          }}
        />
      </div>
    </Router>
  );
}

export default App;